import type { ReactNode, JSX } from "react";

import { cn } from "@repo/cn";

import { FlowHeader } from "@/components/ui/flow-header/flow-header";
import { Page } from "@/components/ui/layout/page/page";
import { RoundedLayout } from "@/components/ui/layout/rounded-layout";

interface ProgressRoundedLayoutProps {
  children: ReactNode;
  progress: number;
  onBack?: () => void;
  showBackButton?: boolean;
  className?: string;
}

export const ProgressRoundedLayout = ({
  children,
  progress,
  onBack,
  className,
  showBackButton = true,
}: ProgressRoundedLayoutProps): JSX.Element => (
  <RoundedLayout>
    <FlowHeader>
      <FlowHeader.Actions>
        {showBackButton ? <FlowHeader.BackButton onBack={onBack} /> : null}
        <FlowHeader.HelpButton />
      </FlowHeader.Actions>
      <FlowHeader.ProgressBar progress={progress} />
    </FlowHeader>
    <Page
      className={cn("flex flex-col gap-6 px-6 pt-0", className)}
      showCustomerIoContainer={false}
    >
      {children}
    </Page>
  </RoundedLayout>
);
